import { LogosProps } from '@zola/zola-ui/src/components/PreAuthV3/Logos';

import AirbnbDesktop from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Desktop/airbnb.png';
import BrooklinenDesktop from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Desktop/brooklinen.png';
import CrateAndBarrelDesktop from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Desktop/CrateandBarrel.png';
import CuisinartDesktop from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Desktop/Cuisinart.png';
import KichtenaidDesktop from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Desktop/Kitchenaid.png';
import LeCreusetDesktop from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Desktop/LeCreuset.png';
import LenoxDesktop from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Desktop/Lenox.png';
import SonosDesktop from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Desktop/Sonos.png';
import WaterfordDesktop from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Desktop/Waterford.png';
import YetiDesktop from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Desktop/Yeti.png';

import AirbnbMobile from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Mobile/airbnb.png';
import BrooklinenMobile from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Mobile/brooklinen.png';
import CrateAndBarrelMobile from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Mobile/CrateandBarrel.png';
import CuisinartMobile from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Mobile/Cuisinart.png';
import KichtenaidMobile from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Mobile/Kitchenaid.png';
import LeCreusetMobile from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Mobile/LeCreuset.png';
import LenoxMobile from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Mobile/Lenox.png';
import SonosMobile from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Mobile/Sonos.png';
import WaterfordMobile from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Mobile/Waterford.png';
import YetiMobile from '../../../public/static-preauth/images/WeddingRegistryLP/V3/Logos/Mobile/Yeti.png';

const AirbnbLogo = {
  mobileSrc: AirbnbMobile,
  tabletSrc: AirbnbMobile,
  desktopSrc: AirbnbDesktop,
  imgType: 'png',
};

const BrooklinenLogo = {
  mobileSrc: BrooklinenMobile,
  tabletSrc: BrooklinenMobile,
  desktopSrc: BrooklinenDesktop,
  imgType: 'png',
};
const CrateAndBarrelLogo = {
  mobileSrc: CrateAndBarrelMobile,
  tabletSrc: CrateAndBarrelMobile,
  desktopSrc: CrateAndBarrelDesktop,
  imgType: 'png',
};

const CuisinartLogo = {
  mobileSrc: CuisinartMobile,
  tabletSrc: CuisinartMobile,
  desktopSrc: CuisinartDesktop,
  imgType: 'png',
};

const KichtenaidLogo = {
  mobileSrc: KichtenaidMobile,
  tabletSrc: KichtenaidMobile,
  desktopSrc: KichtenaidDesktop,
  imgType: 'png',
};

const LeCreusetLogo = {
  mobileSrc: LeCreusetMobile,
  tabletSrc: LeCreusetMobile,
  desktopSrc: LeCreusetDesktop,
  imgType: 'png',
};

const LenoxLogo = {
  mobileSrc: LenoxMobile,
  tabletSrc: LenoxMobile,
  desktopSrc: LenoxDesktop,
  imgType: 'png',
};

const SonosLogo = {
  mobileSrc: SonosMobile,
  tabletSrc: SonosMobile,
  desktopSrc: SonosDesktop,
  imgType: 'png',
};

const WaterfordLogo = {
  mobileSrc: WaterfordMobile,
  tabletSrc: WaterfordMobile,
  desktopSrc: WaterfordDesktop,
  imgType: 'png',
};

const YetiLogo = {
  mobileSrc: YetiMobile,
  tabletSrc: YetiMobile,
  desktopSrc: YetiDesktop,
  imgType: 'png',
};

export const logos: LogosProps = {
  logos: [
    CrateAndBarrelLogo,
    KichtenaidLogo,
    LeCreusetLogo,
    BrooklinenLogo,
    LenoxLogo,
    WaterfordLogo,
    SonosLogo,
    YetiLogo,
    AirbnbLogo,
    CuisinartLogo,
  ],
};
